import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import ImageToPdf from './pages/ImageToPdf';

import MergePdf from './pages/MergePdf';
import SplitPdf from './pages/SplitPdf';
import RotatePdf from './pages/RotatePdf';
import RearrangePdf from './pages/RearrangePdf';
import WatermarkPdf from './pages/WatermarkPdf';
import PdfToJpg from './pages/PdfToJpg';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import DummyTool1 from './pages/DummyTool1';
import DataAnalyzer from './pages/DataAnalyzer';
import ExpenseReportList from './pages/expenses/ExpenseReportList';
import ExpenseReportForm from './pages/expenses/ExpenseReportForm';
import LeaveDashboard from './pages/leaves/LeaveDashboard';
import AdminConfig from './pages/admin/AdminConfig';
import UserManagement from './pages/admin/UserManagement';
import HolidayManagement from './pages/admin/HolidayManagement';
import WorkflowConfig from './pages/admin/WorkflowConfig';
import DepartmentManagement from './pages/admin/DepartmentManagement';
import SystemLogs from './pages/admin/SystemLogs';
import PayrollManagement from './pages/admin/PayrollManagement';
import MySalary from './pages/MySalary';
import Attendance from './pages/Attendance';
import AttendanceManagement from './pages/admin/AttendanceManagement';
import Profile from './pages/Profile';
import HelpCenter from './pages/HelpCenter';

function App() {
  const [orgName, setOrgName] = React.useState('');

  React.useEffect(() => {
    const fetchConfig = async () => {
      try {
        const api = (await import('./services/api')).default;
        const response = await api.get('/auth/config');
        setOrgName(response.data.orgName);
      } catch (err) {
        console.error('Failed to fetch org config for footer', err);
      }
    };
    fetchConfig();
  }, []);

  return (
    <Router>
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/*" element={
            <ProtectedRoute>
              <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
                <Navbar />
                <Routes>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/tools/pdf" element={<Home />} />
                  <Route path="/image-to-pdf" element={<ImageToPdf />} />
                  <Route path="/merge-pdf" element={<MergePdf />} />
                  <Route path="/split-pdf" element={<SplitPdf />} />
                  <Route path="/rotate-pdf" element={<RotatePdf />} />
                  <Route path="/rearrange-pdf" element={<RearrangePdf />} />
                  <Route path="/watermark-pdf" element={<WatermarkPdf />} />
                  <Route path="/pdf-to-jpg" element={<PdfToJpg />} />
                  <Route path="/tools/dummy1" element={<DataAnalyzer />} />
                  <Route path="/tools/expenses" element={<ExpenseReportList />} />
                  <Route path="/tools/expenses/new" element={<ExpenseReportForm />} />
                  <Route path="/tools/expenses/:id" element={<ExpenseReportForm />} />
                  <Route path="/tools/leaves" element={<LeaveDashboard />} />
                  <Route path="/admin/config" element={<AdminConfig />} />
                  <Route path="/admin/users" element={<ProtectedRoute requiredRole={['ADMIN']}><UserManagement /></ProtectedRoute>} />
                  <Route path="/admin/holidays" element={<ProtectedRoute requiredRole={['ADMIN', 'HR']}><HolidayManagement /></ProtectedRoute>} />
                  <Route path="/admin/workflow" element={<ProtectedRoute requiredRole={['ADMIN', 'HR']}><WorkflowConfig /></ProtectedRoute>} />
                  <Route path="/admin/departments" element={<ProtectedRoute requiredRole={['ADMIN', 'HR']}><DepartmentManagement /></ProtectedRoute>} />
                  <Route path="/admin/logs" element={<ProtectedRoute requiredRole={['ADMIN']}><SystemLogs /></ProtectedRoute>} />
                  <Route path="/admin/payroll" element={<ProtectedRoute requiredRole={['ADMIN', 'HR']}><PayrollManagement /></ProtectedRoute>} />
                  <Route path="/leaves" element={<ProtectedRoute><LeaveDashboard /></ProtectedRoute>} />
                  <Route path="/my-salary" element={<ProtectedRoute><MySalary /></ProtectedRoute>} />
                  <Route path="/attendance" element={<ProtectedRoute><Attendance /></ProtectedRoute>} />
                  <Route path="/admin/attendance" element={<ProtectedRoute requiredRole={['ADMIN', 'HR']}><AttendanceManagement /></ProtectedRoute>} />
                  <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                  <Route path="/help" element={<ProtectedRoute><HelpCenter /></ProtectedRoute>} />

                  {/* Default Route */}
                </Routes>
                <footer className="flex-center" style={{ marginTop: 'auto', padding: '2rem', color: 'var(--text-muted)' }}>
                  <p>© {new Date().getFullYear()} {orgName || 'Tool Lab'}. All rights reserved.</p>
                </footer>
              </div>
            </ProtectedRoute>
          } />
        </Routes>
      </div>
    </Router >
  );
}

export default App;
